import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigationType } from 'react-router-dom'

import { locationChange } from '@disco/state-management/actions/RouterActions'
import type { RouterLocation } from '@disco/state-management/reducers/router'

export const useRouterSync = () => {
  const location = useLocation()
  const navigationType = useNavigationType()
  const dispatch = useDispatch()

  useEffect(() => {
    const routerLocation: RouterLocation = {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state,
      key: location.key,
    }

    dispatch(locationChange(routerLocation, navigationType) as any)
  }, [location, navigationType, dispatch])
}
